import React, { useEffect, useRef, useState } from 'react'
import { getEmpsProfilesAPI } from '../../../../services/employee'
import moment from 'moment'
import { Card } from 'react-bootstrap'
import FromImage from './form-image'
import FormPresonal from './form-presonal'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

function PersonalProfile() {
  // let [searchParams, setSearchParams] = useSearchParams()
  // const orgId = searchParams.get('orgId')
  // const code = searchParams.get('code')

  const { profile: profileDetail } = useSelector(
    (state) => state.profileReducer
  )

  const orgId = profileDetail?.orgId
  const code = profileDetail?.code

  const [profile, setProfile] = useState({})
  const [onQrCode, setOnQrCode] = useState(false)

  useEffect(() => {
    moment.locale('en')
  }, [])

  useEffect(() => {
    const getEmpsProfiles = async () => {
      const data = await getEmpsProfilesAPI({ orgId, code })
      if (!data) return
      if (data.status) {
        setProfile(data.result[0])
      }
    }
    if (orgId && code) {
      getEmpsProfiles()
    }
  }, [orgId, code])

  return (
    <>
      <Card.Body className="pt-3 ">
        <div className="d-flex ">
          <div
            className="p-2 overflow-auto"
            style={{ minWidth: '350px', maxWidth: '350px', height: '78vh' }}
          >
            <FormPresonal profile={profile} onQrCode={onQrCode} />
          </div>
          <div
            className="pe-3 ps-3  overflow-auto "
            style={{ height: '78vh', width: '100%' }}
          >
            <FromImage />
          </div>
        </div>
      </Card.Body>
    </>
  )
}

export default PersonalProfile
